import React, { memo } from 'react';
import { Typography } from '@mui/material';
import { withTrackProps } from '@dpdgroupuk/react-event-tracker';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import palette from '../../styles/palette';
import { OK, UNABLE_PROCEED_PICKUP_REQUEST } from '../../../constants/strings';
import { PICKUP_STOP_MODAL } from '../../../constants/analytics';

const PickupStops = ({ open, onClose, onConfirm }) => (
  <SimpleModal
    onClose={onClose}
    open={open}
    title="PICKUP STOPS"
    loadId={PICKUP_STOP_MODAL.LOAD}
    actions={
      <Button
        minWidthZero
        onClick={onConfirm}
        bgColor={palette.btn.blueFill}
        border={palette.btn.blueBorder}
      >
        {OK}
      </Button>
    }
  >
    <Typography>{UNABLE_PROCEED_PICKUP_REQUEST}</Typography>
  </SimpleModal>
);

export default withTrackProps({ onConfirm: PICKUP_STOP_MODAL.CLICK_OK })(
  memo(PickupStops)
);
